import React from "react";
import styled from "styled-components/macro";

import media from "../theme/media";

import Info from "./Info";
import ProgressBarComplete from "./ProgressBarComplete";
import colors from "../theme/colors";

type Props = {
  isProtectedPerson?: boolean;
  courtName: string;
};

const ExitContentEvr: React.FC<Props> = ({ isProtectedPerson = true, courtName }) => (
  <div>
    <p>
      A{" "}
      <Info
        displayText="registrar"
        headingText="Registrar"
        bodyText="A court officer responsible for maintaining a register or record of court proceedings."
        inherit
      />{" "}
      will review your application and attempt to contact you within the next five (5) business days to discuss your application.
      If you have chosen telephone contact, the{" "}
      <Info
        displayText="registrar"
        headingText="Registrar"
        bodyText="A court officer responsible for maintaining a register or record of court proceedings."
        inherit
      />{" "}
      will call you from a private number within business hours. If you have
      said it is not safe for the court to telephone or email you, please contact <strong>{courtName}</strong>{" "}
      within the next seven (7) business days. To learn more about your local court see{" "}
        <a
        href="https://www.mcv.vic.gov.au/going-court/find-court"
        target="_blank"
        rel="noreferrer"
        title="Find a court"
        style={{ color: colors.blue }}
      >
        here
      </a>. If your circumstances change, please contact the court. If you are in immediate danger, call triple zero (000).
    </p>
    <ProgressBarComplete />

    <TopSpacer />
    <div>
      <h2>What you’ll discuss with the registrar</h2>
      <p>
        The{" "}
        <Info
          displayText="registrar"
          headingText="Registrar"
          bodyText="A court officer responsible for maintaining a register or record of court proceedings."
          inherit
        />{" "}
        will talk to you about:
      </p>
      <ul>
        <li>the details of your application</li>
        <li>the intervention order process and what to expect</li>
        <li>a time and date for the possible court hearing</li>
        <li>any safety concerns you might have</li>
      </ul>
      <p>
        Please note that the Magistrates' Court is open during business hours
        only, Monday to Friday and is not open on public holidays.
      </p>
    </div>
  </div>
);

export default ExitContentEvr;

const TopSpacer = styled.div`
  height: 0;
  ${media.greaterThan("phone")`
    height: 50px;
  `}
`;
